import { Controller } from "@hotwired/stimulus"

// Davis-Bacon on a project (Kloepfer K9-21): the wage determination number
// shows only while "Davis-Bacon job" is ticked. New-project Details step and
// the Edit project pop-up (projects/_davis_bacon_fields).
export default class extends Controller {
  static targets = ["toggle", "details", "number"]

  toggle() {
    const on = this.toggleTarget.checked
    this.detailsTarget.hidden = !on
    if (on) this.numberTarget.focus()
  }
}
